import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useEffect } from "react";

const UpdateRoleModal = ({ user, handleUpdate, isOpen, setIsOpen }) => {
  const { _id, name } = user;
  const backendURL = "https:/3.6.130.138.nip.io/v1";

  const [upgradeRequest, setUpgradeRequest] = useState({
    upgrade_request: false,
    date_initiated: "",
    processed: false,
    reason: "",
    requested_role: "",
    user_id: _id.$oid,
  });

  const fetchData = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      user_id: _id.$oid,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`https:/3.6.130.138.nip.io/v1/user/upgradeget/`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        const { upgrade_request } = result;
        // console.log(upgrade_request);
        setUpgradeRequest({
          upgrade_request: true,
          date_initiated: new Date(
            upgrade_request.date_initiated.$date
          ).toLocaleString(),
          processed: upgrade_request.processed,
          reason: upgrade_request.reason,
          requested_role: upgrade_request.requested_role,
          user_id: upgrade_request.user_id,
        });
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log(upgradeRequest);
  }, [upgradeRequest]);

  return (
    // Modal to update the role based on user id
    <Modal isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Update Role</ModalHeader>
        <ModalCloseButton
          onClick={() => {
            setIsOpen(false);
          }}
        />
        <ModalBody>
          {upgradeRequest.upgrade_request ? (
            <>
              <Text>Upgrade Request from {name}</Text>
              <Text>Reason: {upgradeRequest.reason}</Text>
              <Text>Initiated At: {upgradeRequest.date_initiated}</Text>
              <Text>Requested Role: {upgradeRequest.requested_role}</Text>
            </>
          ) : (
            <>
              <Text>Update role for {name}</Text>
            </>
          )}
          <Select
            my="3"
            placeholder="Select option"
            onChange={(e) => handleUpdate(_id, e.target.value)}
          >
            <option value="admin">Admin</option>
            <option value="viewer">Viewer</option>
            <option value="planner">Planner</option>
          </Select>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default UpdateRoleModal;
